import React, {PureComponent} from "react";
import {Table} from "reactstrap";
import {withTranslation} from "react-i18next";
import {map} from "lodash";

class MessageDetails extends PureComponent {
  render() {
    const {t, message} = this.props;
    const {presentation} = message;
    return (
      <div className="table-row-sub d-flex flex-row p-2">
        {Object.keys(presentation.message).length > 0 &&
          <div className="flex-1 mr-2">
            <div className="font-weight-semibold mb-2">
              {t("Display Info")}:
            </div>
            <Table bordered responsive className="w-100">
              <tbody>
                {map(presentation.message, (value, key) => (
                  typeof value !== "object" ?
                    <tr key={key}>
                      <td style={{width: 150}} className="text-info">{key}</td>
                      <td className="py-1">{value}</td>
                    </tr> :
                    null
                ))}
              </tbody>
            </Table>
          </div>
        }
        {Object.keys(presentation.data).length > 0 &&
          <div className="flex-1">
            <div className="font-weight-semibold mb-2">
              {t("Meta Info")}:
            </div>
            <Table bordered responsive className="w-100">
              <tbody>
                {map(presentation.data, (value, key) => (
                  typeof value !== "object" ?
                    <tr key={key}>
                      <td style={{width: 150}} className="text-info">{key}</td>
                      <td className="py-1">{value}</td>
                    </tr> :
                    null
                ))}
              </tbody>
            </Table>
          </div>
        }
      </div>
    );
  }
}

export default withTranslation()(MessageDetails);